<template>
  <v-card
    class="welcome__bg"
  >
    <v-container
      fluid
      class="fill-height"
    >
      <v-btn
        @click="onClose"
        icon
        absolute
        top
        color="white"
        outlined
        right
        class="welcome__btn-close"
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-row
        class="ma-0 text-center d-flex flex-column pa-8 welcome__row"
      >
        <span class="title font-weight-light info--text text--lighten-4">Olá!</span>
        <span class="headline font-weight-bold white--text text-uppercase">Seja Bem vindo à Mappa</span>
        <span
          class="title font-weight-bold white--text mb-2"
        >A sua plataforma de processamento de imagens de drone.</span>
        <span class="body-2 white--text welcome__text">Prepare-se para conhecer uma nova maneira de ter mapas com alta qualidade e gerir projetos.</span>
        <span class="body-2 white--text welcome__text">Sem computador travado. Com atendimento e suporte no seu idioma.</span>
        <span class="body-2 white--text welcome__text">Aproveite os próximos 7 dias e processe as imagens do seu drone sem custo nenhum.</span>
        <span class="body-2 white--text welcome__text">Navegue em todas as funcionalidades e comprove a rapidez, praticidade e </span>
        <span class="body-2 white--text welcome__text">qualidade dos mapas gerados.</span>
        <span
          class="headline font-weight-bold info--text text--lighten-4 text-uppercase welcome__text-final mt-4"
        >Boa experiência</span>
        <span class="headline font-weight-bold info--text text--lighten-4 text-uppercase">Mappa!</span>
        <v-img
          src="../../../assets/general/logo-mappa-welcome.png"
          max-width="20%"
          class="logo__img hidden-xs-only"
        />
      </v-row>
      <v-btn
        @click="onClose"
        icon
        absolute
        bottom
        color="white"
        left
        class="welcome__btn-close"
      >
        <v-icon>mdi-chevron-triple-left</v-icon>
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
  // import {FLOWS_IDS} from "../../../helpers/conpass/constants"

  export default {
    name: "WelcomeCard",
    methods: {
      onClose() {
        // window.Conpass.startFlow(FLOWS_IDS.ONBOARDING, {show:true})
        this.$emit("close")
      }
    }
  }
</script>

<style scoped lang="scss">

  .welcome__row {
    position: relative;
  }

  .welcome__bg {
    background-image: url("../../../assets/general/background-circles-blue.png");
    background-size: cover;
  }

  .welcome__text {
    line-height: 2.5 !important;
  }

  .welcome__text-final {
    line-height: .8 !important;
  }

  .welcome__btn-close {
    z-index: 9999;
  }

  .logo__img {
    position: absolute;
    bottom: 0;
    right: 0;
    margin: 0 30px 40px 0;
  }

</style>
